var map = {
	"./avatars/avatars.module": [
		"./src/app/avatars/avatars.module.ts",
		"avatars-avatars-module"
	],
	"./cards/cards.module": [
		"./src/app/cards/cards.module.ts",
		"cards-cards-module"
	],
	"./concurrency/concurrency.module": [
		"./src/app/concurrency/concurrency.module.ts",
		"concurrency-concurrency-module"
	],
	"./home/home.module": [
		"./src/app/home/home.module.ts",
		"home-home-module"
	],
	"./ng-content/ng-content.module": [
		"./src/app/ng-content/ng-content.module.ts",
		"ng-content-ng-content-module"
	],
	"./slider/slider.module": [
		"./src/app/slider/slider.module.ts",
		"slider-slider-module"
	],
	"./virtual-scroll/virtual-scroll.module": [
		"./src/app/virtual-scroll/virtual-scroll.module.ts",
		"virtual-scroll-virtual-scroll-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return __webpack_require__.e(ids[1]).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;